// PrivateRoute.tsx
import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getStudySlug, isSingleStudy } from "../helper/study";

interface PrivateRouteProps extends RouteProps {
  component?: React.ComponentType<any>;
  render?: (props: any) => React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  render,
  ...rest
}) => {
  const { isInitialized, isAuthenticated } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isInitialized) return null; // keep Ionic outlet stable
        if (!isAuthenticated)
          return (
            <Redirect
              to={isSingleStudy() ? "/" : `/${getStudySlug()}/welcome`}
            />
          );

        if (Component) {
          return <Component {...props} />;
        }
        if (render) {
          return render(props);
        }
        return null;
      }}
    />
  );
};

export default PrivateRoute;
